import { US, CANADA } from '../value/utils';

const getRegionalInfo = region => {
  if (region === US) {
    return 'us';
  } else if (region === CANADA) {
    return 'canada';
  }
  return 'all';
};

const regionalTrafficValAvg = (region, trafficValAvg) => {
  const regionalValue = `avg_${getRegionalInfo(region)}_traffic`;
  return trafficValAvg[regionalValue];
};

export { getRegionalInfo, regionalTrafficValAvg };



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_level_value/utils.js